<!----
    Author: hjlee
    Description:
        회원 활성화 모달
---->
<template>
  <b-modal
    v-if="configs && user"
    id="modal"
    ref="modalRef"
    :title="$t('user_activation_modal.title.user_activation')"
    :ok-title="$t('common.button.ok')"
    :cancel-title="$t('common.button.cancel')"
    @ok="confirm"
  >
    <div v-html="$t('user_activation_modal.confirm.user_activation', {userNm: user.nm})" />
  </b-modal>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: undefined
    }
  },
  methods: {
    confirm: function(evt) {
      const url = '/user/activate?userId=' + this.user.id
      this.$axios
        .$put(url)
        .then(response => {
          if (response.resultCode === 'success') {
            this.user.sttusCode = response.data
            this.$toast.info(this.$t(response.message, response.params))
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(e => {
          console.error(e)
        })
    }
  }
}
</script>
